import React from 'react';
import { useUserDetails } from "../../../redux/hooks/UserDetails";
import Subscription from './Subscription';
import UserPlanInfo from '../Dashboard/SubComponents/my-profile/UserPlanInfo';


const DisplayUserPlanDetails = () => {
  const { userDetail } = useUserDetails();
  
  // Check if ogUserId exists in userDetail
  const hasOgUserId = userDetail?.ogUserId;

  return (
    <div>
      {hasOgUserId ? <Subscription /> : <UserPlanInfo />}
    </div>
  );
}

export default DisplayUserPlanDetails;
